import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { format, parseISO } from 'date-fns';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';
import { CustomReactSelect, CustomButton, CustomModal, CustomCalendar} from '../../../shared';
import { DownloadCloudIcon, CalendarIcon } from '../../../../assets';

const FilterBar = (props) => {
    const {} = props;
    const dispatch = useDispatch();
    const [calendarOpen, setCalendarOpen] = useState(false);
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    let dateRange = `${format(parseISO(startDateRange), 'MMM dd, yyyy')} -  ${format(parseISO(endDateRange), 'MMM dd, yyyy')}`
    const { companyOptions, company } = useSelector((state) => state.company);
    const { userDetails: { is_admin } } = useSelector((state) => state.user);
    const { setCompany } = companyActions;

    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
    };

    const handleShowCalendar = () => {
        setCalendarOpen(!calendarOpen);
    };

    return (
        <Grid container className="flex-row-justify-start mb-24px mt-10px">
            <Grid item xs={6}>
                <Box className="flex-row gap-12"> 
                    <Box className="w-50">
                        <CustomReactSelect
                            options={companyOptions}
                            handleFilter={handleCompanyChange}
                            selectedOption={{
                                label: company.name,
                                value: company.id,
                            }}
                            customStyle={{ borderRadius: '50px' }}
                            placeholder="Select Company"
                        />
                    </Box>
                    {/* Select Inputs */}
                    <Box className="w-70">
                        <CustomButton
                            title={dateRange}
                            titleColor="#344054"
                            buttonColor="#FFFFFF"
                            icon={<CalendarIcon />}
                            handleClick={handleShowCalendar}
                        />
                        <CustomModal
                            modalOpen={calendarOpen}
                            component={<Box className="custom-modal-calendar-container">
                                <CustomCalendar closeModal={handleShowCalendar} />
                            </Box>}
                            handleClose={handleShowCalendar}
                            onClose={handleShowCalendar}
                        />
                    </Box>
                </Box>
            </Grid>
            
        </Grid>
    );
};

export default FilterBar;
